import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// styles
import './sytle.scss';

// antd component
import { Typography, Button } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import ErrorBoundary from 'engine/ErrorBoundary';

// Communication components
import { FBSectionHeader } from 'components/Communications';

const FBDiscussion = ({
  onDelete,
  name,
  mode,
  className,
  onViewDiscussionClick,
  discussionId,
}) => {
  const childClassNames = classNames('fb-discussion', className);

  return (
    <ErrorBoundary>
      <div className={childClassNames}>
        <FBSectionHeader
          mode={mode}
          type="discussion"
          onDelete={() => onDelete(name)}
        />
        <div className="fb-discussion--container">
          <div className="fb-discussion--container__icon">
            <CustomIcons type="comments" />
          </div>
          <Typography.Text
            level={3}
            className="fb-discussion--container__title"
          >
            La discussion est ouverte
          </Typography.Text>
          <Typography.Paragraph className="fb-discussion--container__desc">
            Les destinataires de cette communication pourront interagir sous
            forme de chat.
          </Typography.Paragraph>
          <Button
            className="fb-discussion--container__button"
            disabled={!discussionId}
            onClick={onViewDiscussionClick}
          >
            Voir la discussion
          </Button>
        </div>
      </div>
    </ErrorBoundary>
  );
};

FBDiscussion.defaultProps = {
  name: 'discussion',
  mode: 'edit',
};
FBDiscussion.propTypes = {
  onDelete: PropTypes.func,
  mode: PropTypes.oneOf(['edit', 'onlyRead', 'preview', 'new']).isRequired,
};

export default FBDiscussion;
